var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VSwitch',{staticClass:"inline-switch v-input--reverse",attrs:{"label":`Show ${_vm.label}`,"ripple":false},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})
}
var staticRenderFns = []

export { render, staticRenderFns }